import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getOffsetTop } from 'client/utils/offset-top';
import { useOnScreen } from 'site-modules/shared/hooks/use-on-screen';

import './right-rail-sticky-interscroll.scss';

const getDelta = (elemYpos, scrollPos) => (((elemYpos - scrollPos) / window.innerHeight) * -8 + 1).toFixed(2);

export function RightRailStickyInterscroll({ children }) {
  const ref = React.useRef();
  const isTicking = React.useRef(false);
  const [isOnScreen] = useOnScreen(ref, { root: null, rootMargin: '0px', threshold: 0.1 });

  function onRafTick(scrollPos) {
    const refYpos = getOffsetTop(ref.current);
    const delta = getDelta(refYpos, scrollPos);

    const parentRow = ref.current.closest('.row');
    const parentYpos = getOffsetTop(parentRow);
    const parentDelta = getDelta(parentYpos, scrollPos);

    ref.current.style.transform = `translate3d(0, ${delta}%, 0)`;
    ref.current.style.top = `${(parentDelta * -2 + 8).toFixed(2)}%`;
  }

  function rafEventListener() {
    const scrollY = window.scrollY;

    if (!isTicking.current) {
      window.requestAnimationFrame(() => {
        onRafTick(scrollY);
        isTicking.current = false;
      });
      isTicking.current = true;
    }
  }

  useEffect(() => {
    onRafTick(window.scrollY);
  }, []);

  useEffect(() => {
    if (isOnScreen) {
      document.addEventListener('scroll', rafEventListener, false);
    } else {
      document.removeEventListener('scroll', rafEventListener, false);
    }

    return () => document.removeEventListener('scroll', rafEventListener, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnScreen]);

  return (
    <div className="right-rail-ad-cluster-sticky" ref={ref}>
      {children}
    </div>
  );
}

RightRailStickyInterscroll.propTypes = {
  children: PropTypes.node,
};

RightRailStickyInterscroll.defaultProps = {
  children: null,
};
